import React from 'react'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import { updateObject } from 'helpers/objectHelpers'

const YoutubeSettings = ({
  value,
  value: {
    loop,
    autoplay,
    controls,
    showinfo,
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <div>
      <FormCheckbox
        label="Autoplay"
        value={autoplay}
        onChange={(val) => handleChange(val, 'autoplay')}
      />
      <FormCheckbox
        label="Play as Loop"
        value={loop}
        onChange={(val) => handleChange(val, 'loop')}
      />
      <FormCheckbox
        label="Show video controls"
        value={controls}
        onChange={(val) => handleChange(val, 'controls')}
      />
      <FormCheckbox
        label="Show video info"
        value={showinfo}
        onChange={(val) => handleChange(val, 'showinfo')}
      />
    </div>
  )
}

YoutubeSettings.propTypes = {}
YoutubeSettings.defaultProps = {}

export default YoutubeSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/youtube/YoutubeSettings.js